import React, { memo, ReactNode } from 'react';

interface FormFieldLoadingStateProps {
  children: ReactNode;
}

const FormFieldLoadingState: React.FC<FormFieldLoadingStateProps> = ({
  children,
}) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-start gap-x-3">
        <div className="w-28 h-5 bg-loading/background-2 rounded-default" />
        <div className="w-5 h-5 rounded-full bg-loading/background-2" />
      </div>
      {children}
    </div>
  );
};

export default memo(FormFieldLoadingState);
